import { FieldComponent } from '@jutro/components';
import { TranslatorContext } from '@jutro/locale';
import React from 'react';
import styles from './FieldLinkComponent.module.scss';

import { Link } from '@jutro/router';

class FieldLinkComponent extends FieldComponent {
    static contextType = TranslatorContext;

    static propTypes = {
        ...FieldComponent.propTypes,
    };

    renderControl() {
        const { value } = this.props;
        return (
            <Link className={styles.fieldLinkColor} {...this.props}>
                {value}
            </Link>
        );
    }

    render() {
        return super.render();
    }
}

export default FieldLinkComponent;
